import React from "react"
import { ResponsiveHeatMapCanvas } from '@nivo/heatmap'
import General from "./data/General"
import {
    Container,
    Col,
    Row,
    Button
} from 'reactstrap'
import {isMobile} from 'react-device-detect';

class ChartViz extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show:true,
            mobile:isMobile,
            tappedfirst:false
        }
        this.handletoggle = this.handletoggle.bind(this);
        this.handlebtoggle = this.handlebtoggle.bind(this);

      }
      handletoggle(){
        if (this.state.mobile === true && this.state.tappedfirst===false){
            this.setState(prevState => {
                return {
                    show: !this.state.show,
                    tappedfirst:true
                }
            })
        }
        else if (this.state.mobile === false && this.state.tappedfirst===false){
            this.setState(prevState => {
                return {
                    show: !this.state.show,
                    tappedfirst:false
                }
            })
        }
    }
    handlebtoggle(){
        if (this.state.mobile === true && this.state.tappedfirst===false){
            this.setState(prevState => {
                return {
                    show: !this.state.show,
                    tappedfirst:true
                }
            })
        }else{
            this.setState(prevState => {
                return {
                    show: !this.state.show,
                    tappedfirst:false
                }
            })
        }
    }
    render()
    {
        let hoverboxtop = (this.state.show && !this.state.mobile)? <em className="gray pad--20">لمعرفة المزيد انقر على الرسم البياني في الأسفل. الدول مرتبة حسب المناطق</em> : <div><em className="gray pad--20">قم بجولة بين الأعمدة لمزيد من المعلومات حول بلدك</em></div>
        let hoverboxbottom= (this.state.show && !this.state.mobile)? <div><span>&nbsp;</span><em className="gray pad--20">لمعرفة المزيد انقر على الرسم البياني في الأعلى</em></div> : <div><span>&nbsp;</span><em className="gray pad--20">قم بجولة بين الأعمدة لمزيد من المعلومات حول بلدك</em></div>
        
        if (this.state.mobile){
            hoverboxtop= this.state.show?<em className="gray pad--20"></em> : <div><em className="gray pad--20">قم بجولة بين الأعمدة لمزيد من المعلومات حول بلدك</em></div>
            hoverboxbottom= this.state.show ? <div><span>&nbsp;</span><em className="gray pad--20">لمعرفة المزيد أنقر على الرسم البياني في الأعلى</em></div> : <div><span>&nbsp;</span><em className="gray pad--20">قم بجولة بين الأعمدة لمزيد من المعلومات حول بلدك</em></div>
        }

        let contann = <div style={{ display: this.state.show? "block":"none", height: this.props.height-80}} className="toggleannotate">
            {this.props.cont}
        </div>

        let yesannotate = <div style={{ display: this.state.show? "block":"none", height: this.props.height-80}} className="toggleannotate">
            {this.props.leftbox}
        </div>
        let absannotate = <div style={{ display: this.state.show? "block":"none", height: this.props.height-80}} className="toggleannotate">
             {this.props.absbox}
        </div>
        let noannotate = <div style={{ display: this.state.show? "block":"none", height: this.props.height-80}} className="toggleannotate">
             {this.props.rightbox}
        </div>

        let continent = this.props.continent =="all" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
        <svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
        <rect x="0" y={this.props.height/86.8} width="100%" height="0.06" className="eeeeee"/>
        <rect x="0" y={this.props.height/58.6} width="100%" height="0.06" className="eeeeee"/>
        <rect x="0" y={this.props.height/50.4} width="100%" height="0.06" className="eeeeee"/>
        <rect x="0" y={this.props.height/34.17} width="100%" height="0.06" className="eeeeee"/>
        <rect x="0" y={this.props.height/28.27} width="100%" height="0.06" className="eeeeee"/>
        <rect x="0" y={this.props.height/25.6} width="100%" height="0.06" className="eeeeee"/>
        </svg>
        </div>:""

let annotate40 = this.props.continent =="1940" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/32} width="100%" height="0.18" className="eeeeee"/>
<rect x="0" y={this.props.height/22.7} width="100%" height="0.18" className="eeeeee"/>
<rect x="0" y={this.props.height/20.9} width="100%" height="0.18" className="eeeeee"/>
<rect x="0" y={this.props.height/13} width="100%" height="0.18" className="eeeeee"/>
<rect x="0" y={this.props.height/8.81} width="100%" height="0.18" className="eeeeee"/>
<rect x="0" y={this.props.height/7.69} width="100%" height="0.18" className="eeeeee"/>
</svg>
</div>:""

let annotate50 = this.props.continent =="1950" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/52.5} width="100%" height="0.16" className="eeeeee"/>
<rect x="0" y={this.props.height/30.4} width="100%" height="0.16" className="eeeeee"/>
<rect x="0" y={this.props.height/28.7} width="100%" height="0.16" className="eeeeee"/>
<rect x="0" y={this.props.height/16.5} width="100%" height="0.16" className="eeeeee"/>
<rect x="0" y={this.props.height/12.45} width="100%" height="0.16" className="eeeeee"/>
<rect x="0" y={this.props.height/10.73} width="100%" height="0.16" className="eeeeee"/>
</svg>
</div>:""

let annotate60 = this.props.continent =="1960" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/43.8} width="100%" height="0.12" className="eeeeee"/>
<rect x="0" y={this.props.height/32.7} width="100%" height="0.12" className="eeeeee"/>
<rect x="0" y={this.props.height/31.9} width="100%" height="0.12" className="eeeeee"/>
<rect x="0" y={this.props.height/22.71} width="100%" height="0.12" className="eeeeee"/>
<rect x="0" y={this.props.height/18.27} width="100%" height="0.12" className="eeeeee"/>
<rect x="0" y={this.props.height/16.15} width="100%" height="0.12" className="eeeeee"/>
</svg>
</div>:""

let annotate70 = this.props.continent =="1970" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/54.6} width="100%" height="0.09" className="eeeeee"/>
<rect x="0" y={this.props.height/40} width="100%" height="0.09" className="eeeeee"/>
<rect x="0" y={this.props.height/37.2} width="100%" height="0.09" className="eeeeee"/>
<rect x="0" y={this.props.height/27.4} width="100%" height="0.09" className="eeeeee"/>
<rect x="0" y={this.props.height/22.05} width="100%" height="0.09" className="eeeeee"/>
<rect x="0" y={this.props.height/19.35} width="100%" height="0.09" className="eeeeee"/>
</svg>
</div>:""

let annotate80 = this.props.continent =="1980" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/58.4} width="100%" height="0.07" className="eeeeee"/>
<rect x="0" y={this.props.height/42.5} width="100%" height="0.07" className="eeeeee"/>
<rect x="0" y={this.props.height/39.1} width="100%" height="0.07" className="eeeeee"/>
<rect x="0" y={this.props.height/29.12} width="100%" height="0.07" className="eeeeee"/>
<rect x="0" y={this.props.height/22.75} width="100%" height="0.07" className="eeeeee"/>
<rect x="0" y={this.props.height/20.1} width="100%" height="0.07" className="eeeeee"/>
</svg>
</div>:""

let annotate90 = this.props.continent =="1990" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/76.6} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/51.8} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/46.6} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/32.1} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/26.12} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/23.6} width="100%" height="0.06" className="eeeeee"/>
</svg>
</div>:""

let annotate00 = this.props.continent =="2000" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/83.5} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/56.4} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/48.4} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/33.1} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/27.2} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/24.7} width="100%" height="0.06" className="eeeeee"/>
</svg>
</div>:""


let annotate10 = this.props.continent =="2010" ?<div style={{ height: this.props.height+50 }} className="amazingbean">
<svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
<rect x="0" y={this.props.height/82.2} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/55.85} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/47.9} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/33.12} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/27.2} width="100%" height="0.06" className="eeeeee"/>
<rect x="0" y={this.props.height/24.7} width="100%" height="0.06" className="eeeeee"/>
</svg>
</div>:""

        return(
              <div>
                {hoverboxtop}    
                <Button size="lg" onClick={this.handlebtoggle} className="annotationbutton">{this.state.show? "إخفاء الشروح":"إظهار الشروح"}</Button>
                <Container onClick={this.handletoggle} fluid className="no-gutters no-padding">
                  <Row style={{ height: this.props.height }} className="no-gutters dataviz justify-content-center">
                  <Col md="1" className="d-none d-md-block text-left">{contann}</Col>
                        <Col lg="8" md="10" className="text-left">
                            <div className="votingpattern">
                            <div className="votepatternbox infavour display-3">
                            <h4>صوتوا بنعم</h4>
                            {yesannotate}
                            </div>
                            <div className="votepatternbox abstained display-3">
                            <h4>امتنعوا عن التصويت</h4>
                            {absannotate}
                            </div>
                            <div className="votepatternbox against display-3">
                            <h4>صوتوا بلا</h4>
                            {noannotate}
                            </div>
                            </div>
                        <div style={{ height: this.props.height+50 }} className="amazing">
                            <svg height="100%" width="100%" viewBox="0 0 100 100"  preserveAspectRatio="none">
                            <rect width="33%" height="100%" className="rectstyle recyay"/>
                            <rect x="33.5%" width="33%" height="100%" className="rectstyle recabs"/>
                            <rect x="67%" width="33%" height="100%" className="rectstyle recnay"/>
                            </svg>
                        </div>
                        {continent}
                        {annotate40}
                        {annotate50}
                        {annotate60}
                        {annotate70}
                        {annotate80}
                        {annotate90}
                        {annotate00}
                        {annotate10}
                    
        <ResponsiveHeatMapCanvas
        data={this.props.dataset}
        keys={[
            "ME (YAY)",
            "NU (YAY)",
            "DI (YAY)",
            "HR (YAY)",
            "CO (YAY)",
            "EC (YAY)",
            // "-",
            "ME (ABS)",
            "NU (ABS)",
            "DI (ABS)",
            "HR (ABS)",
            "CO (ABS)",
            "EC (ABS)",
            // "*",
            "ME (NAY)",
            "NU (NAY)",
            "DI (NAY)",
            "HR (NAY)",
            "CO (NAY)",
            "EC (NAY)",
        ]}
        indexBy={this.props.language}
        colors={["#00ffff"]}
        margin={{ top: 100, right: 120, bottom: 10, left: 10 }}
        pixelRatio={2}
        minValue="auto"
        maxValue="auto"
        forceSquare={false}
        sizeVariation={1}
        padding={0}
        axisTop={{ orient: 'top', tickSize: 5, tickPadding: 5, tickRotation: -90, legend: '', legendOffset: 36 }}
        axisLeft={null}
        // axisBottom={{
        //     orient: 'bottom',
        //     tickSize: 5,
        //     tickPadding: 5,
        //     tickRotation: -90,
        //     legend: '',
        //     legendPosition: 'middle',
        //     legendOffset: 36
        // }}
        axisBottom={null}
        axisRight={{
            orient: 'right',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 36
        }}
        enableGridX={false}
        enableGridY={true}
        cellShape="rect"
        cellOpacity={1}
        cellBorderWidth={0}
        cellBorderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
        enableLabels={false}
        labelTextColor={{ theme: 'background' }}
        animate={true}
        motionStiffness={120}
        motionDamping={9}
        isInteractive={true}
        hoverTarget="rowColumn"
        cellHoverOpacity={1}
        cellHoverOthersOpacity={0.1}
        height={this.props.height}
    />
    </Col>
    </Row>
    </Container>
    <br/>
    {hoverboxbottom}
    <Button size="lg" onClick={this.handlebtoggle} className="annotationbutton">{this.state.show? "إخفاء الشروح":"إظهار الشروح"}</Button>

      </div>
    )
}
}
export default ChartViz

